import type React from 'react';
import type { LabResultResponse } from '../../../../generated/openapi/befunde-api';
import { ObservationResultsRenderer } from './orderresult/observationresult/ObservationResultsRenderer.tsx';
import { SpecimenRenderer } from './orderresult/specimen/SpecimenRenderer.tsx';

export const LabResultSingleRenderer: React.FC<{
  result: LabResultResponse;
  deemphasizePathological: boolean;
}> = ({ result, deemphasizePathological }) => {
  return (
    <>
      <SpecimenRenderer result={result} />
      <ObservationResultsRenderer result={result} deemphasizePathological={deemphasizePathological} />
    </>
  );
};
